import React, { useState, useEffect } from "react";
import Portfolio2 from "../Items/Portfolio2";

const filters = [
  {
    id: 1,
    name: "All Projects",
  },
  {
    id: 2,
    name: "Web Design",
  },
  {
    id: 3,
    name: "React.Js",
  },
  {
    id: 4,
    name: "Laravel (PHP)",
  },
  {
    id: 5,
    name: "Full-Stack",
  },
];

const allData = [
  {
    id: 1,
    name: "Timmyshop",
    category: ["React.Js", "Full-Stack"],
    image: "images/portfolio/tshop_.png",
    slug: "timmyshop",
  },
  {
    id: 2,
    name: "The Talk Doctor",
    category: ["Web Design"],
    image: "images/portfolio/thetalkdoctor_.png",
    slug: "talk-doctor",
  },
  {
    id: 3,
    name: "De Cloud23",
    category: ["Web Design"],
    image: "images/portfolio/decloud23_.png",
    slug: "de-cloud23",
  },
  {
    id: 4,
    name: "Booking Website",
    category: ["Web Design", "Laravel (PHP)", "Full-Stack"],
    image: "images/portfolio/cornerstone_.png",
    slug: "booking-website",
  },
  {
    id: 5,
    name: "Portfolio Website",
    category: ["React.Js"],
    image: "images/portfolio/portfolio_.png",
    slug: "portfolio-portal",
  },
  {
    id: 6,
    name: "Portfolio Website2",
    category: ["React.Js"],
    image: "images/portfolio/portfolio2_.png",
    slug: "portfolio-web",
  },
  {
    id: 7,
    name: "Tech Landing Page",
    category: ["React.Js"],
    image: "images/portfolio/tech-startup_.png",
    slug: "tech-landing-page",
  },
  {
    id: 8,
    name: "Pinnacle Domain Global",
    category: ["Web Design"],
    image: "images/portfolio/pinnacle_.png",
    slug: "pinnacle-domain-global",
  },
  {
    id: 9,
    name: "Penchin Global Services Limited (PGSL)",
    category: ["Web Design"],
    image: "images/portfolio/penchingroup_.png",
    slug: "penchin",
  },
];

function Portfolios2() {
  const [getAllItems] = useState(allData);
  const [dataVisibleCount, setDataVisibleCount] = useState(6);
  const [dataIncrement] = useState(3);
  const [activeFilter, setActiveFilter] = useState("");
  const [visibleItems, setVisibleItems] = useState([]);
  const [noMorePost, setNoMorePost] = useState(false);

  useEffect(() => {
    setActiveFilter(filters[0].name);
    setVisibleItems(getAllItems.filter((item) => item.id <= 6));
  }, [getAllItems]);

  const handleChange = (e) => {
    console.log(e.target.value);
    e.preventDefault();
    let targetFilter = e.target.value
      ? e.target.value
      : e.target.textContent;
    setActiveFilter(targetFilter);
    let tempData;
    if (targetFilter === filters[0].name) {
      tempData = getAllItems.filter((data) => data.id <= dataVisibleCount);
    } else {
      tempData = getAllItems.filter((data) => {
        return (
          data.category.includes(targetFilter) && data.id <= dataVisibleCount
        );
      });
    }
    setVisibleItems(tempData);
  };

  const handleLoadmore = (e) => {
    e.preventDefault();
    let tempCount = dataVisibleCount + dataIncrement;

    if (tempCount > getAllItems.length) {
      setNoMorePost(true);
    } else {
      setDataVisibleCount(tempCount);
      if (activeFilter === filters[0].name) {
        setVisibleItems(getAllItems.filter((data) => data.id <= tempCount));
      } else {
        let items = getAllItems.filter((data) => {
          return data.category.includes(activeFilter) && data.id <= tempCount;
        });
        setVisibleItems(items);
      }
    }
  };

  return (
    <>
      <ul className="portfolio-filter list-inline">
        {filters.map((filter) => (
          <li
            className={
              filter.name === activeFilter
                ? "list-inline-item current"
                : "list-inline-item"
            }
            key={filter.id}
            onClick={handleChange}
          >
            {filter.name}
          </li>
        ))}
      </ul>

      <div className="pf-filter-wrapper mb-4">
        <select
          className="portfolio-filter-mobile"
          onChange={(e) => handleChange(e)}
        >
          {filters.map((filter) => (
            <option value={filter.name} key={filter.id}>
              {filter.name}
            </option>
          ))}
        </select>
      </div>

      <div className="row portfolio-wrapper">
        {visibleItems.map((item) => (
          <div className="col-md-4 col-sm-6 grid-item" key={item.id}>
            <Portfolio2 portfolio={item} />
          </div>
        ))}
      </div>

      {noMorePost ? null : (
        <div className="load-more text-center mt-4">
          <a
            href="#!"
            className="btn btn-default"
            onClick={(e) => handleLoadmore(e)}
          >
            <i className="fas fa-circle-notch"></i> Load more
          </a>
        </div>
      )}
    </>
  );
}

export default Portfolios2;
